/**
 * Returns the Jamaica states list to populate the select item.
 */
 export function gluky_addressfield_rd_states_list() {
  let temporalStates = [];
  const states =
  {
    '01' : 'Distrito Nacional',
    '02' : 'Azua',
    '03' : 'Baoruco',
    '04' : 'Barahona',
    '05' : 'Dajabón',
    '06' : 'Duarte',
    '07' : 'El Seibo',
    '08' : 'Elías Piña',
    '09' : 'Espaillat',
    '10' : 'Hato Mayor',
    '11' : 'Hermanas Mirabal',
    '12' : 'Independencia',
    '13' : 'La Altagracia',
    '14' : 'La Romana',
    '15' : 'La Vega',
    '16' : 'María Trinidad Sánchez',
    '17' : 'Monseñor Nouel',
    '18' : 'Montecristi',
    '19' : 'Monte Plata',
    '20' : 'Pedernales',
    '21' : 'Peravia',
    '22' : 'Puerto Plata',
    '23' : 'Samaná',
    '24' : 'San Cristóbal',
    '25' : 'San José de Ocoa',
    '26' : 'San Juan',
    '27' : 'San Pedro de Macorís',
    '28' : 'Sánchez Ramírez',
    '29' : 'Santiago',
    '30' : 'Santiago Rodríguez',
    '31' : 'Santo Domingo',
    '32' : 'Valverde',
  }

  Object.keys(states).map((res) => {
    temporalStates = [
      ...temporalStates,
      {
        name: states[res],
        code: res,
      },
    ];
  });
  return temporalStates;
}

/**
 * Returns the Jamaica cities list by state code to populate the select item.
 *
 * @param $state_code
 *   The DANE state code
 * @return
 */
 export function gluky_addressfield_rd_cities_list($state_code) {
  let temporalCities = [];
  const $data = {
    '01': {
      '01001' : 'Distrito Nacional',
    },
    '02': {
      '02001' : 'Azua de Compostela',
      '02002' : 'Estebanía',
      '02003' : 'Guayabal',
      '02004' : 'Las Charcas',
      '02005' : 'Las Yayas de Viajama',
      '02006' : 'Padre Las Casas',
      '02007' : 'Peralta',
      '02008' : 'Pueblo Viejo',
      '02009' : 'Sabana Yegua',
      '02010' : 'Tábara Arriba',
    },
    '03': {
      '03001' : 'Neiba',
      '03002' : 'Galván',
      '03003' : 'Los Ríos',
      '03004' : 'Tamayo',
      '03005' : 'Villa Jaragua',
    },
    '04': {
      '04001' : 'Barahona',
      '04002' : 'Cabral',
      '04003' : 'El Peñón',
      '04004' : 'Enriquillo',
      '04005' : 'Fundación',
      '04006' : 'Jaquimeyes',
      '04007' : 'La Ciénaga',
      '04008' : 'Las Salinas',
      '04009' : 'Paraíso',
      '04010' : 'Polo',
      '04011' : 'Vicente Noble',
    },
    '05': {
      '05001' : 'Dajabón',
      '05002' : 'El Pino',
      '05003' : 'Loma de Cabrera',
      '05004' : 'Partido',
      '05005' : 'Restauración',
    },
    '06': {
      '06001' : 'San Francisco de Macorís',
      '06002' : 'Arenoso',
      '06003' : 'Castillo',
      '06004' : 'Eugenio María de Hostos',
      '06005' : 'Las Guáranas',
      '06006' : 'Pimentel',
      '06007' : 'Villa Riva',
    },
    '07': {
      '07001' : 'El Seibo',
      '07002' : 'Miches',
    },
    '08': {
      '08001' : 'Comendador',
      '08002' : ' Bánica',
      '08003' : 'El Llano',
      '08004' : 'Hondo Valle',
      '08005' : 'Juan Santiago',
      '08006' : 'Pedro Santana',    
    },
    '09': {
      '09001' : 'Moca',
      '09002' : 'Cayetano Germosén',
      '09003' : 'Gaspar Hernández',
      '09004' : 'Jamao al Norte',
    },
    '10': {
      '10001' : 'Hato Mayor del Rey',
      '10002' : 'El Valle',
      '10003' : 'Sabana de la Mar',
    },
    '11': {
      '11001' : 'Salcedo',
      '11002' : 'Tenares',
      '11003' : 'Villa Tapia',
    },
    '12': {
      '12001' : 'Jimaní',
      '12002' : 'Cristóbal',
      '12003' : 'Duvergé',
      '12004' : 'La Descubierta',
      '12005' : 'Mella',
      '12006' : 'Postrer Río',
    },
    '13': {
      '13001' : 'Higüey',
      '13002' : 'San Rafael del Yuma',
    },
    '14': {
      '14001' : 'La Romana',
      '14002' : 'Guaymate',
      '14003' : 'Villa Hermosa',
    },
    '15': {
      '15001' : 'La Concepción de La Vega',
      '15002' : 'Constanza',
      '15003' : 'Jarabacoa',
      '15004' : 'Jima Abajo',
    },
    '16': {
      '16001' : 'Nagua',
      '16002' : 'Cabrera',
      '16003' : 'El Factor',
      '16004' : 'Río San Juan',
    },
    '17': {
      '17001' : 'Bonao',
      '17002' : 'Maimón',
      '17003' : 'Piedra Blanca',
    },
    '18': {
      '18001' : 'Montecristi',
      '18002' : 'Castañuelas',
      '18003' : 'Guayubín',
      '18004' : 'Las Matas de Santa Cruz',
      '18005' : 'Pepillo Salcedo',
      '18006' : 'Villa Vásquez',
    },
    '19': {
      '19001' : 'Monte Plata',
      '19002' : 'Bayaguana',
      '19003' : 'Peralvillo',
      '19004' : 'Sabana Grande de Boyá',
      '19005' : 'Yamasá',      
   },
    '20': {
      '20001' : 'Pedernales',
      '20002' : 'Oviedo',
   }, 
    '21': {
      '21001' : 'Baní',
      '21002' : 'Nizao',
    },
    '22': {
      '22001' : 'Puerto Plata',
      '22002' : 'Altamira',
      '22003' : 'Guananico',
      '22004' : 'Imbert',
      '22005' : 'Los Hidalgos',
      '22006' : 'Luperón',
      '22007' : 'Sosúa',
      '22008' : 'Villa Isabela',
      '22009' : 'Villa Montellano',
    },
    '23': {
      '23001' : 'Samaná',
      '23002' : 'Las Terrenas',
      '23003' : 'Sánchez',
    },
    '24': {
      '24001' : 'San Cristóbal',
      '24002' : 'Bajos de Haina',
      '24003' : 'Cambita Garabitos',
      '24004' : 'Los Cacaos',
      '24005' : 'Sabana Grande de Palenque',
      '24006' : 'San Gregorio de Nigua',
      '24007' : 'Villa Altagracia',
      '24008' : 'Yaguate',
    },
    '25': {
      '25001' : 'San José de Ocoa',
      '25002' : 'Rancho Arriba',
      '25003' : 'Sabana Larga',
    },
    '26': {
      '26001' : 'San Juan de la Maguana',
      '26002' : 'Bohechío',
      '26003' : 'El Cercado',
      '26004' : 'Juan de Herrera',
      '26005' : 'Las Matas de Farfán',
      '26006' : 'Vallejuelo',
    },
    '27': {
      '27001' : 'San Pedro de Macorís',
      '27002' : 'Consuelo',
      '27003' : 'Guayacanes',
      '27004' : 'Quisqueya',
      '27005' : 'Ramón Santana',
      '27006' : 'San José de los Llanos',
    },
    '28': {
      '28001' : 'Cotuí',
      '28002' : 'Cevicos',
      '28003' : 'Fantino',
      '28004' : 'La Mata',
    }, 
    '29': {
      '29001' : 'Santiago',
      '29002' : 'Bisonó',
      '29003' : 'Jánico',
      '29004' : 'Licey al Medio',
      '29005' : 'Puñal',
      '29006' : 'Sabana Iglesia',
      '29007' : 'San José de las Matas',
      '29008' : 'Tamboril',
      '29009' : 'Villa González',
    },
    '30': {
      '30001' : 'San Ignacio de Sabaneta',
      '30002' : 'Los Almácigos',
      '30003' : 'Monción',
    },
    '31': {
      '31001' : 'Santo Domingo Este',
      '31002' : 'Boca Chica',
      '31003' : 'Los Alcarrizos',
      '31004' : 'Pedro Brand',
      '31005' : 'San Antonio de Guerra',
      '31006' : 'Santo Domingo Norte',
      '31007' : 'Santo Domingo Oeste',
    },
    '32': {
      '32001' : 'Mao',
      '32002' : 'Esperanza',
      '32003' : 'Laguna Salada',   
    },
  };


  const cities = $data[$state_code] ? $data[$state_code] : null;
  Object.keys(cities).map((citie) => {
    temporalCities = [
      ...temporalCities,
      {
        name: cities[citie],
        code: citie,
      },
    ];
  });
  return temporalCities;
}

export function gluky_addressfield_rd_localities_list($state_code, $city_code) {
  let temporalLocalities = [];
  const $data = {
    '01': {
      '01001': {
        '01001001': 'Distrito Nacional'
      }
    },
    '02': {
      '02001': {
        '02001001': 'Barreras',
        '02001002': 'Barro Arriba',
        '02001003': 'Clavellina',
        '02001004': 'Emma Balaguer Viuda Vallejo',
        '02001005': 'Las Barías-La Estancia',
        '02001006': 'Las Lomas',
        '02001007': 'Los Jovillos',
        '02001008': 'Puerto Viejo'
      },
      '02002': {
        '02002002': 'Estebanía'
      },
      '02003': {
        '02003003': 'Guayabal'
      },
      '02004': {
        '02004001': 'Hatillo',
        '02004002': 'Palmar de Ocoa'
      },
      '02005': {
        '02005001': 'Villarpando',
        '02005002': 'Hato Nuevo-Cortés'
      },
      '02006': {
        '02006001': 'La Siembra',
        '02006002': 'Las Lagunas',
        '02006003': 'Los Fríos'
      },
      '02007': {
        '02007007': 'Peralta'
      },
      '02008': {
        '02008001': 'El Rosario'
      },
      '02009': {
        '02009001': 'Proyecto 4',
        '02009002': 'Ganadero',
        '02009003': 'Proyecto 2-C'
      },
      '02010': {
        '02010001': 'Amiama Gómez',
        '02010002': 'Los Toros',
        '02010003': 'Tábara Abajo'
      }
    },
    '03': {
      '03001': {
        '03001001': 'El Palmar'
      },
      '03002': {
        '03002001': 'El Salado'
      },
      '03003': {
        '03003001': 'Las Clavellinas'
      },
      '03004': {
        '03004001': 'Cabeza de Toro',
        '03004002': 'Mena',
        '03004003': 'Monserrat',
        '03004004': 'Santa Bárbara-El 6',
        '03004005': 'Santana',
        '03004006': 'Uvilla'
      },
      '03005': {
        '03005005': 'Villa Jaragua'
      }
    },
    '04': {
      '04001': {
        '04001001': 'El Cachón',
        '04001002': 'La Guázara',
        '04001003': 'Villa Central'
      },
      '04002': {
        '04002002': 'Cabral'
      },
      '04003': {
        '04003003': 'El Peñón'
      },
      '04004': {
        '04004001': 'Arroyo Dulce'
      },
      '04005': {
        '04005001': 'Pescadería'
      },
      '04006': {
        '04006001': 'Palo Alto'
      },
      '04007': {
        '04007001': 'Bahoruco'
      },
      '04008': {
        '04008008': 'Las Salinas'
      },
      '04009': {
        '04009001': 'Los Patos'
      },
      '04010': {
        '04010010': 'Polo'
      },
      '04011': {
        '04011001': 'Canoa',
        '04011002': 'Fondo Negro',
        '04011003': 'Quita Coraza'
      }
    },
    '05': {
      '05001': {
        '05001001': 'Cañongo'
      },
      '05002': {
        '05002001': 'Manuel Bueno'
      },
      '05003': {
        '05003001': 'Capotillo',
        '05003002': 'Santiago de la Cruz'
      },
      '05004': {
        '05004004': 'Partido'
      },
      '05005': {
        '05005005': 'Restauración'
      }
    },
    '06': {
      '06001': {
        '06001001': 'Cenoví',
        '06001002': 'Jaya',
        '06001003': 'La Peña',
        '06001004': 'Presidente Don Antonio Guzmán Fernández'
      },
      '06002': {
        '06002001': 'Aguacate',
        '06002002': 'Las Coles'
      },
      '06003': {
        '06003003': 'Castillo'
      },
      '06004': {
        '06004001': 'Sabana Grande'
      },
      '06005': {
        '06005005': 'Las Guáranas'
      },
      '06006': {
        '06006006': 'Pimentel'
      },
      '06007': {
        '06007001': 'Agua Santa del Yuna',
        '06007002': 'Barraquito',
        '06007003': 'Cristo Rey de Guaraguao',
        '06007004': 'Las Táranas'
      }
    },
    '07': {
      '07001': {
        '07001001': 'Pedro Sánchez',
        '07001002': 'San Francisco-Vicentillo',
        '07001003': 'Santa Lucía'
      },
      '07002': {
        '07002001': 'El Cedro',
        '07002002': 'La Gina'
      }
    },
    '08': {
      '08001': {
        '08001001': 'Guayabo',
        '08001002': 'Sabana Larga'
      },
      '08002': {
        '08002001': 'Sabana Cruz',
        '08002002': 'Sabana Higüero'
      },
      '08003': {
        '08003001': 'Guanito'
      },
      '08004': {
        '08004001': 'Rancho de la Guardia'
      },
      '08005': {
        '08005005': 'Juan Santiago'
      },
      '08006': {
        '08006001': 'Río Limpio'
      }
    },
    '09': {
      '09001': {
        '09001001': 'Canca La Reina',
        '09001002': 'El Higüerito',
        '09001003': 'José Contreras',
        '09001004': 'Juan López',
        '09001005': 'La Ortega',
        '09001006': 'Las Lagunas',
        '09001007': 'Monte de la Jagua',
        '09001008': 'San Víctor'
      },
      '09002': {
        '09002002': 'Cayetano Germosén'
      },
      '09003': {
        '09003001': 'Joba Arriba',
        '09003002': 'Veragua',
        '09003003': 'Villa Magante'
      },
      '09004': {
        '09004004': 'Jamao al Norte'
      }
    },
    '10': {
      '10001': {
        '10001001': 'Guayabo Dulce',
        '10001002': 'Mata Palacio',
        '10001003': 'Yerba Buena'
      },
      '10002': {
        '10002002': 'El Valle'
      },
      '10003': {
        '10003001': 'Elupina Cordero de Las Cañitas'
      }
    },
    '11': {
      '11001': {
        '11001001': 'Jamao Afuera'
      },
      '11002': {
        '11002001': 'Blanco'
      },
      '11003': {
        '11003003': 'Villa Tapia'
      }
    },
    '12': {
      '12001': {
        '12001001': 'Boca de Cachón',
        '12001002': 'El Limón'
      },
      '12002': {
        '12002001': 'Batey 8'
      },
      '12003': {
        '12003001': 'Vengan a Ver'
      },
      '12004': {
        '12004004': 'La Descubierta'
      },
      '12005': {
        '12005001': 'La Colonia'
      },
      '12006': {
        '12006001': 'Guayabal'
      }
    },
    '13': {
      '13001': {
        '13001001': 'La Otra Banda',
        '13001002': 'Lagunas de Nisibón',
        '13001003': 'Verón-Punta Cana'
      },
      '13002': {
        '13002001': 'Bayahibe',
        '13002002': 'Boca de Yuma'
      }
    },
    '14': {
      '14001': {
        '14001001': 'Caleta'
      },
      '14002': {
        '14002002': 'Guaymate'
      },
      '14003': {
        '14003001': 'Cumayasa'
      }
    },
    '15': {
      '15001': {
        '15001001': 'El Ranchito',
        '15001002': 'Río Verde Arriba'
      },
      '15002': {
        '15002001': 'La Sabina',
        '15002002': 'Tireo'
      },
      '15003': {
        '15003001': 'Buena Vista',
        '15003002': 'Manabao'
      },
      '15004': {
        '15004001': 'Rincón'
      }
    },
    '16': {
      '16001': {
        '16001001': 'Arroyo al Medio',
        '16001002': 'Las Gordas',
        '16001003': 'San José de Matanzas'
      },
      '16002': {
        '16002001': 'Arroyo Salado',
        '16002002': 'La Entrada'
      },
      '16003': {
        '16003001': 'El Pozo'
      },
      '16004': {
        '16004004': 'Río San Juan'
      }
    },
    '17': {
      '17001': {
        '17001001': 'Arroyo Toro-Masipedro',
        '17001002': 'La Salvia-Los Quemados',
        '17001003': 'Jayaco',
        '17001004': 'Juma Bejucal',
        '17001005': 'Sabana del Puerto'
      },
      '17002': {
        '17002002': 'Maimón'
      },
      '17003': {
        '17003001': 'Juan Adrián',
        '17003002': 'Villa Sonador'
      }
    },
    '18': {
      '18001': {
        '18001001': 'Montecristi'
      },
      '18002': {
        '18002001': 'Palo Verde'
      },
      '18003': {
        '18003001': 'Cana Chapetón',
        '18003002': 'Hatillo Palma',
        '18003003': 'Villa Elisa'
      },
      '18004': {
        '18004004': 'Las Matas de Santa Cruz'
      },
      '18005': {
        '18005005': 'Pepillo Salcedo'
      },
      '18006': {
        '18006006': 'Villa Vásquez'
      }
    },
    '19': {
      '19001': {
        '19001001': 'Boyá',
        '19001002': 'Chirino',
        '19001003': 'Don Juan'
      },
      '19002': {
        '19002002': 'Bayaguana'
      },
      '19003': {
        '19003003': 'Peralvillo'
      },
      '19004': {
        '19004001': 'Gonzalo',
        '19004002': 'Majagual'
      },
      '19005': {
        '19005001': 'Los Botados'
      }
    },
    '20': {
      '20001': {
        '20001001': 'José Francisco Peña Gómez',
        '20001002': 'Juancho'
      },
      '20002': {
        '20002002': 'Oviedo'
      }
    },
    '21': {
      '21001': {
        '21001001': 'Catalina',
        '21001002': 'El Carretón',
        '21001003': 'El Limonal',
        '21001004': 'Las Barías',
        '21001005': 'Matanzas',
        '21001006': 'Paya',
        '21001007': 'Sabana Buey',
        '21001008': 'Villa Fundación',
        '21001009': 'Villa Sombrero'
      },
      '21002': {
        '21002001': 'Pizarrete',
        '21002002': 'Santana'
      }
    },
    '22': {
      '22001': {
        '22001001': 'Maimón',
        '22001002': 'Yásica Arriba'
      },
      '22002': {
        '22002001': 'Río Grande'
      },
      '22003': {
        '22003003': 'Guananico'
      },
      '22004': {
        '22004004': 'Imbert'
      },
      '22005': {
        '22005001': 'Navas'
      },
      '22006': {
        '22006001': 'Belloso',
        '22006002': 'Estrecho',
        '22006003': 'La Isabela'
      },
      '22007': {
        '22007001': 'Cabarete',
        '22007002': 'Sabaneta de Yásica'
      },
      '22008': {
        '22008001': 'Estero Hondo',
        '22008002': 'Gualete',
        '22008003': 'La Jaiba'
      },
      '22009': {
        '22009009': 'Villa Montellano'
      }
    },
    '23': {
      '23001': {
        '23001001': 'Arroyo Barril',
        '23001002': 'El Limón',
        '23001003': 'Las Galeras'
      },
      '23002': {
        '23002002': 'Las Terrenas'
      },
      '23003': {
        '23003003': 'Sánchez'
      }
    },
    '24': {
      '24001': {
        '24001001': 'Hato Damas'
      },
      '24002': {
        '24002001': 'El Carril'
      },
      '24003': {
        '24003001': 'Cambita El Pueblecito'
      },
      '24004': {
        '24004004': 'Los Cacaos'
      },
      '24005': {
        '24005005': 'Sabana Grande de Palenque'
      },
      '24006': {
        '24006006': 'San Gregorio de Nigua'
      },
      '24007': {
        '24007001': 'La Cuchilla',
        '24007002': 'Medina',
        '24007003': 'San José del Puerto'
      },
      '24008': {
        '24008008': 'Yaguate'
      }
    },
    '25': {
      '25001': {
        '25001001': 'El Naranjal',
        '25001002': 'El Pinar',
        '25001003': 'La Ciénaga',
        '25001004': 'Nizao-Las Auyamas'
      },
      '25002': {
        '25002002': 'Rancho Arriba'
      },
      '25003': {
        '25003003': 'Sabana Larga'
      }
    },
    '26': {
      '26001': {
        '26001001': 'El Rosario',
        '26001002': 'Guanito',
        '26001003': 'Hato del Padre',
        '26001004': 'Hato Nuevo',
        '26001005': 'La Jagua',
        '26001006': 'Las Charcas de María Nova',
        '26001007': 'Pedro Corto',
        '26001008': 'Sabana Alta',
        '26001009': 'Sabaneta'
      },
      '26002': {
        '26002001': 'Arroyo Cano',
        '26002002': 'Yaque'
      },
      '26003': {
        '26003001': 'Batista',
        '26003002': 'Derrumbadero'
      },
      '26004': {
        '26004001': 'Jínova'
      },
      '26005': {
        '26005001': 'Carrera de Yegua',
        '26005002': 'Matayaya'
      },
      '26006': {
        '26006001': 'Jorjillo'
      }
    },
    '27': {
      '27001': {
        '27001001': 'San Pedro de Macorís'
      },
      '27002': {
        '27002002': 'Consuelo'
      },
      '27003': {
        '27003003': 'Guayacanes'
      },
      '27004': {
        '27004001': 'El Puerto',
        '27004002': 'Gautier'
      },
      '27005': {
        '27005005': 'Quisqueya'
      },
      '27006': {
        '27006006': 'Ramón Santana'
      }
    },
    '28': {
      '28001': {
        '28001001': 'Caballero',
        '28001002': 'Comedero Arriba',
        '28001003': 'Quita Sueño'
      },
      '28002': {
        '28002001': 'La Cueva',
        '28002002': 'Platanal'
      },
      '28003': {
        '28003003': 'Fantino'
      },
      '28004': {
        '28004001': 'Angelina',
        '28004002': 'La Bija',
        '28004003': 'Hernando Alonzo'
      }
    },
    '29': {
      '29001': {
        '29001001': 'Baitoa',
        '29001002': 'Hato del Yaque',
        '29001003': 'La Canela',
        '29001004': 'Pedro García',
        '29001005': 'San Francisco de Jacagua',
        '29001006': 'Santiago'
      },
      '29002': {
        '29002002': 'Bisonó'
      },
      '29003': {
        '29003001': 'El Caimito',
        '29003002': 'Juncalito'
      },
      '29004': {
        '29004001': 'Las Palomas'
      },
      '29005': {
        '29005001': 'Canabacoa',
        '29005002': 'Guayabal'
      },
      '29006': {
        '29006006': 'Sabana Iglesia'
      },
      '29007': {
        '29007001': 'Canca La Piedra'
      },
      '29008': {
        '29008001': 'El Rubio',
        '29008002': 'La Cuesta',
        '29008003': 'Las Placetas'
      },
      '29009': {
        '29009001': 'El Limón',
        '29009002': 'Palmar Arriba'
      }
    },
    '30': {
      '30001': {
        '30001001': 'San Ignacio de Sabaneta'
      },
      '30002': {
        '30002002': 'Los Almácigos'
      },
      '30003': {
        '30003003': 'Monción'
      }
    },
    '31': {
      '31001': {
        '31001001': 'San Luis'
      },
      '31002': {
        '31002001': 'La Caleta'
      },
      '31003': {
        '31003001': 'Palmarejo-Villa Linda',
        '31003002': 'Pantoja'
      },
      '31004': {
        '31004001': 'La Cuaba',
        '31004002': 'La Guáyiga'
      },
      '31005': {
        '31005001': 'Hato Viejo'
      },
      '31006': {
        '31006001': 'La Victoria'
      },
      '31007': {
        '31007007': 'Santo Domingo Oeste'
      }
    },
    '32': {
      '32001': {
        '32001001': 'Ámina',
        '32001002': 'Guatapanal',
        '32001003': 'Jaibón (Pueblo Nuevo)'
      },
      '32002': {
        '32002001': 'Boca de Mao',
        '32002002': 'Jicomé',
        '32002003': 'Maizal',
        '32002004': 'Paradero'
      },
      '32003': {
        '32003001': 'Cruce de Guayacanes',
        '32003002': 'Jaibón',
        '32003003': 'La Caya'
      }
    }
  };
  const localities = $data[$state_code][$city_code] ? $data[$state_code][$city_code] : null;

  Object.keys(localities).map(locality => {
    temporalLocalities = [
      ...temporalLocalities,
      {
        name: localities[locality],
        code: locality,
      },
    ];
  });

  return temporalLocalities;
}


